import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { defaultCategorySelector } from './default-category-selector.esm.js';
import { trim } from '../../../utilities/trim.esm.js';

function getCategories(categories, defaultValue) {
  if (!categories) {
    return [defaultValue];
  }
  return categories.reduce(function (acc, item) {
    var label = trim(item.label);
    if (!(label !== null && label !== void 0 && label.length)) {
      return acc;
    }
    return [].concat(_toConsumableArray(acc), [{
      label: label,
      id: item.label
    }]);
  }, [defaultValue]);
}
var createCategoriesSelector = function createCategoriesSelector() {
  return createSelector(function (props) {
    return props.categories;
  }, defaultCategorySelector, getCategories);
};

export { createCategoriesSelector };
//# sourceMappingURL=categories-selector.esm.js.map
